"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.PlanForTiles = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _TilesWrapped = require("../../../components/tile/TilesWrapped");

var _PlanForTile = _interopRequireDefault(require("./PlanForTile"));

var _class;

var PlanForTiles = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(PlanForTiles, _Component);

  function PlanForTiles(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = PlanForTiles.prototype;

  _proto.render = function render() {
    var planFors = this.props.planFors;
    return _react.default.createElement(_TilesWrapped.TilesWrapped, null, planFors.map(function (planFor) {
      return _react.default.createElement(_PlanForTile.default, {
        key: planFor.id,
        planFor: planFor
      });
    }));
  };

  return PlanForTiles;
}(_react.Component)) || _class;

exports.PlanForTiles = PlanForTiles;